import { BusinesscardContactSchemeDefinition } from "./businesscard-contact-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createBusinesscardContactMapDefinition } from "../../../utils/scheme-helper";
import { BusinesscardContactSchemeConfiguration } from "../../../constants/colors";

export const CARD_ALIGNMENT_LEFT = "left";
export const CARD_ALIGNMENT_RIGHT = "right";
export const CARD_ALIGNMENTS = [CARD_ALIGNMENT_LEFT, CARD_ALIGNMENT_RIGHT] as const;
export const CARD_INFO_TEXT_SIZE_H5 = "h5";
export const CARD_INFO_TEXT_SIZE_ABSTRACT = "abstract";
export const CARD_INFO_TEXT_SIZES = [CARD_INFO_TEXT_SIZE_H5, CARD_INFO_TEXT_SIZE_ABSTRACT] as const;

export const ICON_PHONE = "phone";
export const ICON_FAX = "fax";
export const ICON_MAIL = "notification";
export const ICON_TWITTER = "social_twitter";
export const ICON_FACEBOOK = "social_facebook";
export const ICON_LINKEDIN = "social_linked_in";
export const ICON_INSTAGRAM = "social_instagram";

export const LINK_ICONS = [
  ICON_PHONE,
  ICON_FAX,
  ICON_MAIL,
  ICON_TWITTER,
  ICON_FACEBOOK,
  ICON_LINKEDIN,
  ICON_INSTAGRAM
] as const;

export const LinkIcons = {
  phone: ICON_PHONE,
  fax: ICON_FAX,
  mail: ICON_MAIL,
  twitter: ICON_TWITTER,
  facebook: ICON_FACEBOOK,
  linkedin: ICON_LINKEDIN,
  instagram: ICON_INSTAGRAM
};

function createSchemes() {
  let newSchemes: BusinesscardContactSchemeConfiguration<BusinesscardContactSchemeDefinition> = {};

  AllColors.BUSINESSCARD_CONTACT_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      backgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      textcolor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const BUSINESSCARD_CONTACT_SCHEME_CONFIG: AllColors.BusinesscardContactSchemeConfiguration<BusinesscardContactSchemeDefinition> = createSchemes();

export const BUSINESSCARD_CONTACT_SCHEME_MAP: Map<
  BackgroundColor | "default",
  BusinesscardContactSchemeDefinition
> = new Map(
  Object.entries(createBusinesscardContactMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    BUSINESSCARD_CONTACT_SCHEME_CONFIG[config as string]
  ])
);
